import {Component, effect} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatBadge} from '@angular/material/badge';
import {Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import {NgClass} from '@angular/common';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-side-navigation',
  imports: [
    MatIcon,
    MatBadge,
    NgClass,
    MatButton,
    TranslatePipe
  ],
  templateUrl: './side-navigation.component.html',
  styleUrl: './side-navigation.component.scss'
})
export class SideNavigationComponent {

  casesLink: string | undefined = undefined;
  memberLink: string | undefined = undefined;
  unassignedCaseCount = 0;

  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
    private readonly loadingSpinnerService: LoadingSpinnerService) {
    effect(() => {
      if (this.sessionService.session()?.currentTeam?._links.hasLink("memberships")) {
        this.memberLink = this.sessionService.session()?.currentTeam?._links?.getLink("memberships")?.getRoute();
      } else {
        this.memberLink = undefined;
      }
      if (this.sessionService.session()?.currentTeam?._links.hasLink("caseOverview")) {
        this.casesLink = this.sessionService.session()?.currentTeam?._links?.getLink("caseOverview")?.getRoute();
      } else {
        this.casesLink = undefined;
      }
      this.unassignedCaseCount = this.sessionService.session()?.currentTeam?.unassignedCaseCount ?? 0;
    });
  }

  navigateTo(link: string | undefined): void {
    if (!link || link === this.router.routerState.snapshot.url) {
      return;
    }
    this.loadingSpinnerService.show();
    this.router.navigate([link]).then((navigated) => {
      if (!navigated) {
        this.loadingSpinnerService.hide();
      }
    }).catch(() => {
      this.loadingSpinnerService.hide();
    });
  }

  isActive(link: string): boolean {
    link = this.removeQueryParams(link);
    return this.router.routerState.snapshot.url.includes(link);
  }

  private removeQueryParams(link: string): string {
    return link.split('?')[0];
  }
}
